<script lang="ts">
import type { ConfirmDialogEmits, ConfirmDialogProps } from '#layers/ui';

export interface PolicyOverrideConfirmDialogProps extends Omit<ConfirmDialogProps, 'description'> {
	action?: string;
	collectionName: string;
}
</script>

<script setup lang="ts">
defineProps<PolicyOverrideConfirmDialogProps>();
const emit = defineEmits<ConfirmDialogEmits>();
</script>

<template>
	<DConfirmDialog v-bind="$props" @close="(value: boolean) => emit('close', value)">
		<template #description>
			<i18n-t v-if="action" keypath="policy.policy_rules.confirm_override_custom_description" tag="span">
				<template #action>
					<span class="font-medium">{{ action }}</span>
				</template>
				<template #collectionName>
					<span class="font-medium">{{ collectionName }}</span>
				</template>
			</i18n-t>
			<i18n-t v-else keypath="policy.policy_rules.confirm_override_custom_all_actions_description" tag="span">
				<template #collectionName>
					<span class="font-medium">{{ collectionName }}</span>
				</template>
			</i18n-t>
		</template>
	</DConfirmDialog>
</template>
